import React from 'react'
import moment from 'moment'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import DetailsBox from '../../../../components/Cards/DetailsBox'

const DemographicsModule = ({ demographics }) => {
  return (
      <DetailsBox
        title="Demographics"
        rows={[
          { label: 'First Name', value: demographics?.firstName },
          { label: 'Last Name', value: demographics?.lastName },
          {
            label: 'Date of Birth',
            value: demographics?.dob
              ? moment(demographics.dob).format('DD/MM/YYYY')
              : demographics?.dobUnkown
              ? 'Unknown'
              : '',
          },
        ]}
      />
  )
}

export default DemographicsModule
